import state from './state.stores'
import getters from './getters.stores'
import mutations from './mutations.stores'
import actions from './actions.stores'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}